import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
const TaglineSection = () => {
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-start justify-content-start">
                    <div className="col-12 col-md-8">
                        <h6 className="fs-14">Tagline</h6>
                        <h1>Five years proven</h1>
                        <p>We've hosted over 100 tech events across online sessions, expert classes, master classes, beginner series, workshops, in-person meetings, hackathons, and community meetups. Datacode knows how to build momentum and keep students engaged.</p>
                        <CustomButton>Button</CustomButton>
                        <CustomButton className="bg-transparent text-dark border ml-4">Button</CustomButton>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TaglineSection;
